const task = {
    state: {
        list: []
    },
    getters: {

    },
    mutations: {
        setTaskList(state, list) {
            state.list = list;
        }
    }
};

export default task;
